import { AppConfig } from '@config/app.config';

export function getTranslatePathByPageType(url: string) {
  return AppConfig.headerTitleTranslateMap[url] || '';
}
